import { Form, useForm } from "react-hook-form";
import FullscreenUiDialog from "../ui-lib/FullscreenDialog";
import { UiDialogInputProps } from "../ui-lib/UiDialog";
import { FormInput } from "../ui-lib/form/FormInput";
import Label from "../ui-lib/Label";
import Button from "../ui-lib/buttons/Button";
import useAuthData from "../../auth/useAuthData";
import { useTeachers } from "../../states/cache-state/useTeachers";
import { Teacher } from "../../models/teacher/teacher";

export type ExternalTeacherFormFields = {
  name: string;
  lastname: string;
  email: string;
};

type ExternalTeacherDialogProps = {
  teacher?: Partial<ExternalTeacherFormFields>;
  onClose: (teacher?: Teacher) => void;
} & Omit<UiDialogInputProps, "title" | "children" | "onClose">;

function CreateExternalTeacherDialog({
  teacher,
  onClose,
  ...props
}: ExternalTeacherDialogProps) {
  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm<ExternalTeacherFormFields>({
    defaultValues: teacher,
    mode: "onSubmit",
  });
  const { addExternalTeacherToSchool } = useTeachers();
  const { currentSchool } = useAuthData();

  const onSubmit = handleSubmit(async (data) => {
    let teacher: Teacher | undefined = undefined;
    if (currentSchool) {
      teacher = await addExternalTeacherToSchool(currentSchool.id, data.email, {
        name: data.name,
        lastname: data.lastname,
        city: "",
        street: "",
        postalCode: "",
      });
    }

    _onClose(teacher);
  });

  const _onClose = (teacher?: Teacher) => {
    reset();
    onClose(teacher);
  };

  return (
    <FullscreenUiDialog
      title="Externe Lehrperson erstellen"
      onClose={() => _onClose(undefined)}
      {...props}
    >
      <Form control={control} className="space-y-2" onSubmit={onSubmit as any}>
        <Label
          text="Vorname"
          position="top"
          labelClass="uppercase font-bold text-th-primary-900"
        >
          <FormInput
            id="name"
            label="Name"
            name="name"
            register={register}
            rules={{
              required: "Name muss ausgefüllt werden",
            }}
            errors={errors}
          ></FormInput>
        </Label>

        <Label
          text="Nachname"
          position="top"
          labelClass="uppercase font-bold text-th-primary-900"
        >
          <FormInput
            id="lastname"
            label="Nachname"
            name="lastname"
            register={register}
            rules={{
              required: "Nachname muss ausgefüllt werden",
            }}
            errors={errors}
          ></FormInput>
        </Label>

        <Label
          text="Email"
          position="top"
          labelClass="uppercase font-bold text-th-primary-900"
        >
          <FormInput
            id="email"
            label="Email"
            name="email"
            register={register}
            type="email"
            rules={{
              required: "Email muss ausgefüllt werden",
              pattern: {
                value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                message: "Email Adresse nicht gültig",
              },
            }}
            errors={errors}
          ></FormInput>
        </Label>

        <Button theme="primary" type="submit" className="ml-auto flex">
          Speichern
        </Button>
      </Form>
    </FullscreenUiDialog>
  );
}

export default CreateExternalTeacherDialog;
